<template>
  <div id="app">
    <div class="page-container">
      <!-- 顶部导航栏 -->
      <van-nav-bar
        title="题目详情"
        left-text="返回"
        left-arrow
        class="custom-navbar"
        @click-left="onBack"
      />

      <!-- 主内容 -->
      <div class="content">
        <!-- 统计栏（新增） -->
        <div class="stats-bar">
          <span>📊 已答：{{ answeredCount }} / {{ total }}</span>
          <span>✅ 正确率：{{ accuracy }}%</span>
          <span v-if="currentItem.collected" style="color: #f7c948;">⭐ 已收藏</span>
        </div>

        <!-- 单题卡片（原v-for改为只显示当前题） -->
        <div class="question-card" v-if="currentItem">
          <!-- 题号 + 标题 -->
          <div class="question-header">
            <span class="question-number">{{ currentIndex + 1 }}</span>
            <span class="question-title">{{ currentItem.title }}</span>
          </div>

          <!-- 题目详情 -->
          <div class="question-body" v-html="currentItem.detail"></div>

          <!-- 参考答案（点击切换显示） -->
          <div class="answer-row" @click="toggleAnswer">
            <van-tag type="primary" class="tag-answer">参考答案</van-tag>
            <span class="answer-text" v-show="showAnswer">{{ currentItem.answer }}</span>
            <span class="answer-placeholder" v-show="!showAnswer">点击显示</span>
          </div>

          <!-- 解题思路（点击切换显示） -->
          <div class="solution-row" @click="toggleSolution">
            <div class="solution-label">
              <van-icon name="edit" size="14" color="#4b6cb7" />
              解题思路 <span style="font-size:12px;color:#999;">（点击展开/收起）</span>
            </div>
            <div class="solution-text" v-show="showSolution" v-html="currentItem.solution"></div>
          </div>

          <!-- 操作按钮区：正确 / 错误 / 收藏（新增） -->
          <div class="action-bar">
            <van-button
              round
              size="small"
              :type="currentItem.userCorrect === true ? 'success' : 'default'"
              icon="success"
              @click="handleCorrect"
            >
              正确
            </van-button>
            <van-button
              round
              size="small"
              :type="currentItem.userCorrect === false ? 'danger' : 'default'"
              icon="cross"
              @click="handleWrong"
            >
              错误
            </van-button>
            <van-button
              round
              size="small"
              :type="currentItem.collected ? 'warning' : 'default'"
              icon="star"
              @click="toggleCollect"
            >
              {{ currentItem.collected ? '已收藏' : '收藏' }}
            </van-button>
          </div>
        </div>

        <!-- 上一题 / 下一题 导航（新增） -->
        <div class="nav-buttons">
          <van-button
            round
            plain
            type="primary"
            icon="arrow-left"
            :disabled="currentIndex === 0"
            @click="prevQuestion"
          >
            上一题
          </van-button>
          <span class="progress">{{ currentIndex + 1 }} / {{ total }}</span>
          <van-button
            round
            plain
            type="primary"
            icon="arrow"
            :disabled="currentIndex === total - 1"
            @click="nextQuestion"
          >
            下一题
          </van-button>
        </div>

        <!-- 分隔线（保留） -->
        <van-divider class="custom-divider">— 共 {{ total }} 道题 —</van-divider>

        <!-- 底部提示（保留并调整文案） -->
        <div class="footer-tip">
          <van-icon name="passed" size="12" /> 点击「正确/错误」判断，参考答案可点击显示
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
//import { showToast} from 'vant/es/image-preview'
//import 'vant/es/show-toast/style'
import { getCurrentInstance } from "vue";
export default {
  name: 'Index',
  setup() {
    const { proxy } = getCurrentInstance();
    // ---------- 题库数据（扩展字段） ----------
    const questionList = ref([
      {
        title: '一次函数平移',
        detail: '一次函数平移遵循 <span class="math">“上加下减”</span> 原则，向下平移 2 个单位，即在 <span class="math">y = 3x</span> 的基础上减 2，得到 <span class="math">y = 3x - 2</span>。',
        answer: 'B',
        solution: '一次函数平移遵循 <span class="math">“上加下减”</span> 原则，向下平移 2 个单位，即在 <span class="math">y = 3x</span> 的基础上减 2，得到 <span class="math">y = 3x - 2</span>。',
        collected: false,   // 是否收藏
        userCorrect: null   // null=未答, true=正确, false=错误
      },
      {
        title: '一次函数象限判断',
        detail: '一次函数 <span class="math">y = kx + b</span>，当图象经过 <span class="highlight">二、三、四</span> 象限时，<span class="math">k &lt; 0</span>，<span class="math">b &lt; 0</span>，此函数中 <span class="math">b = -1 &lt; 0</span>，图象符合，所以 <span class="math">k &lt; 0</span>。',
        answer: 'B',
        solution: '一次函数 <span class="math">y = kx + b</span>，当图象经过 <span class="highlight">二、三、四</span> 象限时，<span class="math">k &lt; 0</span>，<span class="math">b &lt; 0</span>，此函数中 <span class="math">b = -1 &lt; 0</span>，图象符合，所以 <span class="math">k &lt; 0</span>。',
        collected: false,
        userCorrect: null
      },
      {
        title: '一次函数图象与性质',
        detail: '当 <span class="math">x = 0</span> 时，<span class="math">y = 2</span>，<span class="math">y = 2 \\times 0 - 1 = -1</span>，所以图象与 <span class="math">y</span> 轴交于 <span class="math">(0, -1)</span>，A 正确；因为 <span class="math">k = 2 &gt; 0</span>，函数值 <span class="math">y</span> 随自变量 <span class="math">x</span> 的增大而增大，B 错误；当 <span class="math">y = 0</span> 时，<span class="math">x = 2</span>，<span class="math">x = 1 &lt; 0</span>，解得 <span class="math">x &lt; \\dfrac{1}{2}</span>，C 错误；<span class="math">k = 2 &gt; 0</span>，函数值 <span class="math">y</span> 随自变量 <span class="math">x</span> 的增大而增大，D 错误。',
        answer: 'A',
        solution: '当 <span class="math">x = 0</span> 时，<span class="math">y = 2</span>，<span class="math">y = 2 \\times 0 - 1 = -1</span>，所以图象与 <span class="math">y</span> 轴交于 <span class="math">(0, -1)</span>，A 正确；因为 <span class="math">k = 2 &gt; 0</span>，函数值 <span class="math">y</span> 随自变量 <span class="math">x</span> 的增大而增大，B 错误；当 <span class="math">y = 0</span> 时，<span class="math">x = 2</span>，<span class="math">x = 1 &lt; 0</span>，解得 <span class="math">x &lt; \\dfrac{1}{2}</span>，C 错误；<span class="math">k = 2 &gt; 0</span>，函数值 <span class="math">y</span> 随自变量 <span class="math">x</span> 的增大而增大，D 错误。',
        collected: false,
        userCorrect: null
      }
    ])

    // ---------- 状态 ----------
    const currentIndex = ref(0)          // 当前题目索引
    const showAnswer = ref(false)       // 是否显示参考答案
    const showSolution = ref(false)     // 是否显示解题思路

    // ---------- 计算属性 ----------
    const total = computed(() => questionList.value.length)
    const currentItem = computed(() => questionList.value[currentIndex.value])

    // 已答题数（userCorrect !== null）
    const answeredCount = computed(() => {
      return questionList.value.filter(q => q.userCorrect !== null).length
    })

    // 正确率
    const accuracy = computed(() => {
      const answered = questionList.value.filter(q => q.userCorrect !== null)
      if (answered.length === 0) return 0
      const correct = answered.filter(q => q.userCorrect === true).length
      return Math.round((correct / answered.length) * 100)
    })

    // ---------- 方法 ----------
    const onBack = () => {
      //showToast('返回上一页')
       proxy.$router.go(-1);
    }

    // 切换参考答案显示
    const toggleAnswer = () => {
      showAnswer.value = !showAnswer.value
    }

    // 切换解题思路显示
    const toggleSolution = () => {
      showSolution.value = !showSolution.value
    }

    // 判断正确
    const handleCorrect = () => {
      const item = currentItem.value
      if (item.userCorrect === true) {
        item.userCorrect = null
        //showToast('已取消标记')
      } else {
        item.userCorrect = true
        /*showToast({
          message: '✅ 回答正确！',
          icon: 'success',
          duration: 1200
        })*/
      }
    }

    // 判断错误
    const handleWrong = () => {
      const item = currentItem.value
      if (item.userCorrect === false) {
        item.userCorrect = null
        //showToast('已取消标记')
      } else {
        item.userCorrect = false
        /*showToast({
          message: '❌ 回答错误，再想想吧',
          icon: 'cross',
          duration: 1200
        })*/
      }
    }

    // 切换收藏
    const toggleCollect = () => {
      const item = currentItem.value
      item.collected = !item.collected
      //showToast(item.collected ? '⭐ 已收藏' : '已取消收藏')
    }

    // 上一题
    const prevQuestion = () => {
      if (currentIndex.value > 0) {
        currentIndex.value--
        // 切换题目时收起答案和解析
        showAnswer.value = false
        showSolution.value = false
      }
    }

    // 下一题
    const nextQuestion = () => {
      if (currentIndex.value < total.value - 1) {
        currentIndex.value++
        showAnswer.value = false
        showSolution.value = false
      }
    }

    return {
      questionList,
      currentIndex,
      currentItem,
      total,
      answeredCount,
      accuracy,
      showAnswer,
      showSolution,
      onBack,
      toggleAnswer,
      toggleSolution,
      handleCorrect,
      handleWrong,
      toggleCollect,
      prevQuestion,
      nextQuestion
    }
  }
}
</script>

<style scoped>
/* ===== 原有样式保持不变 ===== */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  background-color: #f7f8fa;
  color: #323233;
  padding-bottom: 20px;
}

.page-container {
  max-width: 480px;
  margin: 0 auto;
  background-color: #f7f8fa;
  min-height: 100vh;
}

.custom-navbar {
  background: linear-gradient(135deg, #4b6cb7, #182848);
  color: #fff !important; ;
}
.custom-navbar .van-nav-bar__title {
  color: #fff !important; ;
  font-weight: 600;
  font-size: 18px;
}
.custom-navbar .van-icon {
  color: #fff !important; ;
}
/* 使用深度选择器穿透 Vant 组件内部 */
.custom-navbar ::v-deep .van-nav-bar__title,
.custom-navbar ::v-deep .van-nav-bar__text,
.custom-navbar ::v-deep .van-icon {
  color: #fff !important;
}
.content {
  padding: 14px 16px 30px;
}

/* 统计栏（新增样式） */
.stats-bar {
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #fff;
  padding: 10px 16px;
  margin-bottom: 12px;
  border-radius: 8px;
  font-size: 14px;
  color: #333;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
}
.stats-bar span {
  flex: 1;
  text-align: center;
}

/* 题目卡片（原有样式，未改动） */
.question-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  padding: 18px 18px 16px;
  margin-bottom: 16px;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  position: relative;
  overflow: hidden;
}
.question-card:active {
  transform: scale(0.99);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.04);
}
.question-card::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(180deg, #4b6cb7, #7b92d0);
  border-radius: 12px 0 0 12px;
}

.question-header {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 10px;
}
.question-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 26px;
  height: 26px;
  background: linear-gradient(135deg, #4b6cb7, #6a8bc9);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 1px;
}
.question-title {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a2e;
  line-height: 1.5;
  padding-top: 1px;
}

.question-body {
  font-size: 15px;
  line-height: 1.8;
  color: #2c3e50;
  padding: 8px 0 12px 0;
  margin-left: 34px;
  border-bottom: 1px dashed #ebedf0;
}
.question-body .math {
  font-family: "Times New Roman", serif;
  font-style: italic;
  color: #4b6cb7;
}

.answer-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 0 6px 34px;
  cursor: pointer;  /* 增加点击手型 */
}
.answer-row .van-tag {
  font-size: 13px;
  padding: 2px 12px;
  border-radius: 12px;
  font-weight: 500;
  letter-spacing: 0.5px;
}
.answer-text {
  font-size: 22px;
  font-weight: 700;
  color: #4b6cb7;
  background: rgba(75, 108, 183, 0.08);
  padding: 0 8px;
  border-radius: 6px;
  line-height: 1.4;
  min-width: 28px;
  text-align: center;
}
.answer-placeholder {
  color: #bbb;
  font-size: 14px;
}

.solution-row {
  padding: 6px 0 2px 34px;
  cursor: pointer;  /* 增加点击手型 */
}
.solution-label {
  font-size: 14px;
  font-weight: 600;
  color: #3a4a7a;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.solution-label::after {
  content: '';
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, #e8ecf1, transparent);
  margin-left: 4px;
}
.solution-text {
  font-size: 14px;
  line-height: 1.9;
  color: #505568;
  background: #f8f9fc;
  padding: 10px 14px;
  border-radius: 8px;
  border-left: 3px solid #4b6cb7;
  margin-top: 2px;
}
.solution-text .highlight {
  color: #d63031;
  font-weight: 500;
}
.solution-text .math {
  font-family: "Times New Roman", serif;
  font-style: italic;
  color: #4b6cb7;
}

/* 操作按钮区（新增样式） */
.action-bar {
  display: flex;
  justify-content: space-around;
  margin-top: 16px;
  padding: 8px 0 4px;
  border-top: 1px solid #f0f2f5;
}
.action-bar .van-button {
  width: 80px;
  font-size: 14px;
}

/* 上下题导航（新增样式） */
.nav-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 4px;
  margin: 0 0 12px;
}
.nav-buttons .van-button {
  min-width: 90px;
}
.progress {
  font-size: 16px;
  font-weight: 500;
  color: #4b6cb7;
}

/* 分隔线（原有） */
.custom-divider {
  margin: 6px 0 18px;
  color: #c8cdd4;
  font-size: 12px;
}
.custom-divider .van-divider__content {
  padding: 0 12px;
}

/* 底部提示（原有） */
.footer-tip {
  text-align: center;
  font-size: 12px;
  color: #b0b8c4;
  padding: 6px 0 4px;
  letter-spacing: 0.3px;
}

/* 响应式微调（原有） */
@media (max-width: 380px) {
  .question-body {
    font-size: 14px;
    margin-left: 30px;
  }
  .answer-row {
    padding-left: 30px;
  }
  .solution-row {
    padding-left: 30px;
  }
  .question-number {
    min-width: 22px;
    height: 22px;
    font-size: 12px;
  }
  .question-title {
    font-size: 15px;
  }
  .answer-text {
    font-size: 20px;
  }
}

@media (min-width: 481px) {
  .page-container {
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.06);
    border-left: 1px solid #eef0f4;
    border-right: 1px solid #eef0f4;
  }
}

/* 进入动画（保留） */
.question-card {
  animation: fadeUp 0.4s ease both;
}
.question-card:nth-child(1) {
  animation-delay: 0.05s;
}
@keyframes fadeUp {
  0% {
    opacity: 0;
    transform: translateY(12px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.tag-answer {
  background: linear-gradient(135deg, #4b6cb7, #6a8bc9) !important;
  color: #fff !important;
  border: none !important;
  padding: 2px 14px !important;
  font-weight: 500;
}
</style>